import { useAAside, useADialog } from '@Atoms';
import { useNotes, useDownloadButton } from '@ShelterModule';
import useDataTable from './useDataTable';
import useDataTableFilters from './useDataTableFilters';

export default function () {
  function cleanSharedRefs() {
    cleanAsidesSharedRefs();
    cleanDataTableSharedRefs();
  }

  function cleanAsidesSharedRefs() {
    useAAside().reset();
    useADialog().reset();
    useNotes().reset();
  }

  function cleanDataTableSharedRefs() {
    useDataTable().reset();
    useDataTableFilters().reset();
    useDownloadButton().reset();
  }

  return {
    cleanSharedRefs,
    cleanAsidesSharedRefs,
    cleanDataTableSharedRefs,
  };
}
